import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=5300ec05"
import script from "./UsersList.vue.ts?vue&type=script&lang=ts&external"
export * from "./UsersList.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports